import { format } from "date-fns";

// Serialize a Date to a local calendar-day string (YYYY-MM-DD) for backend
// period filters. Deliberately NOT toISOString(): the accounting/sales listings
// filter on calendar days, and toISOString() would shift a local day boundary
// by the UTC offset (e.g. 01/04 00:00 CEST -> 31/03 22:00Z), pulling the
// neighbouring day into range.
export const formatDateParam = (
  date: Date | null | undefined,
): string | undefined => (date ? format(date, "yyyy-MM-dd") : undefined);
